import { render, staticRenderFns } from "./PlayerColumn.vue?vue&type=template&id=1de6a884&scoped=true&"
import script from "./PlayerColumn.vue?vue&type=script&lang=js&"
export * from "./PlayerColumn.vue?vue&type=script&lang=js&"
import style0 from "./PlayerColumn.vue?vue&type=style&index=0&id=1de6a884&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de6a884",
  null
  
)

export default component.exports